import { C } from "../../styles/theme";

export default function Fld({ label, value, onChange, type = "text", opts, rows }) {
  const s = { width: "100%", padding: "9px 12px", border: `1.5px solid ${C.border}`, borderRadius: 8, fontSize: 14, outline: "none", background: "#fff", boxSizing: "border-box" };
  return (
    <div style={{ marginBottom: 11 }}>
      <label style={{ display: "block", fontSize: 12, fontWeight: 600, color: C.blue, marginBottom: 4 }}>{label}</label>
      {opts ? <select style={s} value={value} onChange={e => onChange(e.target.value)}>{opts.map(o => <option key={o} value={o}>{o}</option>)}</select>
        : rows ? <textarea rows={rows} style={{ ...s, resize: "vertical" }} value={value} onChange={e => onChange(e.target.value)} />
          : <input type={type} style={s} value={value} onChange={e => onChange(e.target.value)} />}
    </div>
  );
}
